import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import { loadFoldersLog, LoadFoldersParam } from '~src/services/api/actionLogs';
import { DbFolderActionLog } from '~src/types/db';
import { useProjectId } from '../useProjectId';

type UseFoldersActionLogProps = Omit<LoadFoldersParam, 'projectId'>;

interface ReturnType {
  logs: DbFolderActionLog[];
  totalCount: number;
}

export const useFoldersActionLog = (
  { createdBy, before, after, skip, take }: UseFoldersActionLogProps = {},
  queryConfig: QueryConfig<ReturnType, AxiosError> & {
    enabled?: boolean;
  }
) => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const foldersActionLogQuery = useQuery<ReturnType, AxiosError>(
    [
      'foldersActionLog',
      {
        projectId: Number(projectId),
        createdBy,
        before,
        after,
        skip,
        take,
      },
    ],
    loadFoldersLog,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return foldersActionLogQuery;
};
